import { useMemo } from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { formatDate } from "../utils";

const columnHelper = createColumnHelper();

/**
 * Creates a date column for `@tanstack/react-table`.
 *
 * @note The values for date columns should be `Date` objects.
 *
 * @param {object} args
 * @param {string} args.id
 * @param {string} [args.header]
 * @param {number} [args.width]
 * @param {(date: Date) => string} [args.dateFormatFn]
 */
function useDateColumn({ id, header, width, dateFormatFn = formatDate }) {
    return useMemo(
        () =>
            columnHelper.accessor(id, {
                header,
                width,
                sortingFn: "datetime",
                cell: (info) => dateFormatFn(info?.getValue()),
            }),
        [id, header, width, dateFormatFn],
    );
}

export default useDateColumn;
